import { render, staticRenderFns } from "./BuyAndBurn.vue?vue&type=template&id=88ab747e&"
import script from "./BuyAndBurn.vue?vue&type=script&lang=js&"
export * from "./BuyAndBurn.vue?vue&type=script&lang=js&"
import style0 from "./BuyAndBurn.vue?vue&type=style&index=0&id=88ab747e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports